import Instance from '../../../Axios';

// New Actions for the app

const GetParceirosLavandaria = () => async (dispatch) => {
  await Instance()
    .get(`/backend/parceiros/lavandariaDropdown`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: 'GET_PARCEIROS_LAVANDARIA', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetParceirosLavandaria;
